import { apiGet, apiPost } from './index'

// 获取训练营列表
const getTrainingList = params => apiGet('/api/camp/mobile', params)

// 获取训练营详情
const getTrainingDetails = params =>
  apiGet(`/api/camp/mobile/${params.campId}`, params)

// 获取训练营详情
const getTrainingFeedback = params =>
  apiGet(`/api/camp/feedback/mobile`, params)

// 解锁训练营
const unlockTraining = params =>
  apiPost('/api/sys/resource/unlock/userUnlock', params)

// 报名训练营
const signTraning = params => apiPost('/api/camp/user', params)

// 学习榜单
const getStudyRecord = params =>
  apiGet(`/api/campStudtCompletedRecord/studyList`, params)

// 学习任务
const getStudyDcc = params => apiGet(`/api/camp/dcc/${params.campId}`, params)

// 获取最近一场直播 - 训练营推荐
const getNewMeeting = params => apiGet(`/api/camp/meeting/mobile`, params)

// 用户评价
const commentTraining = params => apiPost('/api/camp/feedback', params)

const getCampQuestionList = params => apiGet(`/api/question/user/camp/topic/detail/${params.campId}/${params.whichDay}`, params)

const answerQuestion = params => apiPost('/api/camp/question/user', params)

const getIsCorrect = params => apiGet(`/api/camp/question/user/isCorrect/${params.campId}/${params.userId}/${params.questionId}`, params)

const getTrainIsSign = params => apiGet(`/api/camp/user/join/${params.userId}/${params.campId}`, params)

const getQuestionList = params => apiGet(`/api/camp/dcc/list/${params.campId}`, params)
const getQuestionEndList = params => apiGet(`/api/camp/dcc/end/list/${params.campId}`, params)

const getRemind = params => apiGet(`/api/sys/function/remind/${params.userId}/${params.readType}`)

const postRemind = params => apiPost('/api/sys/function/remind', params)

const getTrainingEvaluate = params => apiGet(`/api/camp/feedback/mobile/end`, params)

const getIsEvaluate = params => apiGet(`/api/camp/feedback/sign/${params.userId}/${params.campId}`, params)

export {
  getTrainingList,
  getTrainingDetails,
  getTrainingFeedback,
  unlockTraining,
  signTraning,
  getStudyRecord,
  getStudyDcc,
  getNewMeeting,
  commentTraining,
  getCampQuestionList,
  getIsCorrect,
  answerQuestion,
  getTrainIsSign,
  getQuestionList,
  getQuestionEndList,
  getRemind,
  postRemind,
  getTrainingEvaluate,
  getIsEvaluate
}



// WEBPACK FOOTER //
// ./src/api/training.js